import React from 'react';
import { Link } from 'react-router-dom';

import { MCButton, MCError, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import {
  withRouter,
  scssVariables as variables,
  lang,
  permissions,
  formatDuration
} from 'src/helpers';

import model from 'src/pages/auth/model';
import mainModel from 'src/model';
import LANG_CONST from '../../helpers/lang/const';
import { GoogleButtonContainer } from 'src/components/user/GoogleSignup';

const apiStateId = 'password';
let intervalId = 'AuthPassword';

class Login extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    this.timer(() => model.state.resetExpired > Date.now(), intervalId);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    this.clearTimer(intervalId);
  }

  handleSubmit = (event) => {
    event.preventDefault();
    mainModel.checkConfirmCookiePolicy().then(
      (accept) =>
        accept &&
        model.loginPassword((err, data, success) => {
          if (success && data?.user) {
            permissions.afterLogin(data.user);
          } else if (data?.expired) {
            model.setState({ resetExpired: data.expired });
            this.timer(() => model.state.resetExpired > Date.now(), intervalId);
          }
        })
    );
  };

  render() {
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    let { invalid, error, errorMessage } = createState;

    const expired = model.state.resetExpired;
    const expiredIn = (expired - Date.now()) / 1000;
    const blocked = expiredIn > 0;

    if (error === 'BLOCKED') errorMessage = '';

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
    }

    return (
      <div className={'mc-page-auth-box'}>
        <div className={'mc-box-header'}>
          <h4 className='mc-box-title'>{lang.t(LANG_CONST.hi)}</h4>
          <div className='mc-box-title-note'>{lang.t(LANG_CONST.text.login_des)}</div>
        </div>
        <form className='mc-form' onSubmit={this.handleSubmit}>
          {!!errorMessage && (
            <MCError error={errorMessage} mcTextProps={{ 'data-testid': 'login-error' }} />
          )}

          <GoogleButtonContainer isLogin={true} loading={createState.loading} />
          <TextField
            template={6}
            type='email'
            autoFocus={true}
            name={'username'}
            value={model.input('username')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            label={LANG_CONST.email_address}
            invalid={invalid}
          />
          <TextField
            template={6}
            type='password'
            name={'password'}
            label={LANG_CONST.password}
            value={model.input('password')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            invalid={invalid}
          />

          <div className='mc-label-420' style={{ textAlign: 'right' }}>
            <Link
              to={permissions.PAGES.FORGOT_PASSWORD_PAGE.path}
              style={{ color: variables['colors-mc-primary'] }}
            >
              {lang.t(LANG_CONST.text.forgot_pw)}
            </Link>
          </div>
          <MCButton
            key={this.state.renderId}
            data-testid='login-submit-button'
            large
            radius
            disabled={blocked || createState.loading}
            loading={createState.loading}
            primary
            dark={!blocked}
            light={blocked}
            type='submit'
            label={
              blocked
                ? lang.t(LANG_CONST.buttons.login_in, { duration: formatDuration(expiredIn) })
                : LANG_CONST.buttons.login
            }
          />
          <div className='mc-label-420'>
            <span className=''>{lang.t(LANG_CONST.text.dont_have_account)} </span>
            <Link
              to={model.state.signupUrl}
              onClick={() => model.resetApiState(apiStateId)}
              style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
            >
              {lang.t(LANG_CONST.buttons.signup)}
            </Link>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(Login);
